import animateHome from './animateHome.js';
import animateExpenses from './animateExpenses.js';
import animateSales from './animateSales.js';

$(document).ready(function($) {

  var injectorOptions = {
    evalScripts: 'once',
    each: function(svg) { }
  };

  var SVGsToInject_home = document.querySelectorAll('img.inject-svg.home-svg');
  var SVGsToInject_expenses = document.querySelectorAll('img.inject-svg.expenses-svg');
  var SVGsToInject_sales = document.querySelectorAll('img.inject-svg.sales-svg');

  if (SVGsToInject_home.length) {
    animateHome(SVGsToInject_home, injectorOptions);
  }

  if (SVGsToInject_expenses.length) {
    animateExpenses(SVGsToInject_expenses, injectorOptions);
  }

  if (SVGsToInject_sales.length) {
    animateSales(SVGsToInject_sales, injectorOptions);
  }

});

